import { useState } from "react";

import ResponseData from "../action/ResponseData";
import { AccommodationAction } from "./AccommodationAction.ts";
import { AccommodataionJson } from "./AccommodataionJson.ts";
import Accommodation from "./Accommodation.ts";
import { SaveOnCookie } from "./SaveOnCookie.ts";
function useAccommodationState() {
    const [list, setList] = useState<Array<Accommodation> | null>(null);
    const [list_updated_at, setListUpdatedAt] = useState<Date | null>(null);
    const [item, setItem] = useState(null);
    const [error, setError] = useState(null);

    const loadedListHandler = async (data: ResponseData) => {
        if (data.data) {
            const result = await Promise.resolve(data.data);
            const accommodations: Array<AccommodataionJson> =
                result.accommodations;

            const list = accommodations.map((accommodation) => {
                return new Accommodation(
                    accommodation.id,
                    accommodation.name,
                    accommodation.color,
                    accommodation.short_name
                );
            });
            const str: string = JSON.stringify(list);
            SaveOnCookie.saveList(str);
            setList(list);
            setListUpdatedAt(new Date());
            //console.log("loadedListHandler", data.data);
        }
    };

    const loadedHandler = (data: ResponseData) => {
        if (data.data) {
            setItem(data.data);
        }
    };

    const errorHandler = (data: ResponseData) => {
        setError(data.error);
    };

    const getAccommodation = (token: string, id: number) => {
        AccommodationAction.getById(token, id, loadedHandler, errorHandler);
    };
    const getAccommodationList = (token: string) => {
        AccommodationAction.getList(token, loadedListHandler, errorHandler);
    };

    return {
        accommodation_error: error,
        accommodation: item,
        accommodations: list,
        accommodations_updated_at: list_updated_at,
        getAccommodationList,
        getAccommodation,
    };
}

export default useAccommodationState;
